import { hasAnyScope } from '../permissions/scopePermissions';

export function canAccessNavItem(userScopes, navItem) {
  const normalizedUserScopes = Array.isArray(userScopes) ? userScopes : [];
  if (navItem?.path === '/dashboard' && normalizedUserScopes.length === 0) {
    return true;
  }

  return hasAnyScope(userScopes, navItem?.requiredScopes || []);
}

export function getAccessibleNavItems(userScopes) {
  const items = APP_NAV_ITEMS.filter((item) => canAccessNavItem(userScopes, item));

  if (items.length > 0) {
    return items;
  }

  return APP_NAV_ITEMS.filter((item) => item.path === '/dashboard');
}

export const APP_NAV_ITEMS = [
  {
    path: '/dashboard',
    label: 'Dashboard',
    iconKey: 'dashboard',
    eyebrow: 'FinDesk Dashboard',
    description: 'High-level summary of collections, liquidations, and active field operations.',
    requiredScopes: ['dashboard.view'],
  },
  {
    path: '/product-setup',
    label: 'Product Setup',
    iconKey: 'productSetup',
    eyebrow: 'Product Setup',
    description: 'Product setup module placeholder. We can wire product structure and maintenance flows next.',
    requiredScopes: ['product-setup.view'],
  },
  {
    path: '/agents',
    label: 'Agents',
    iconKey: 'agents',
    eyebrow: 'Agents',
    description: 'Agents module placeholder. We can implement listing, assignment, and onboarding flows next.',
    requiredScopes: ['agents.view'],
  },
  {
    path: '/sales',
    label: 'Sales',
    iconKey: 'sales',
    eyebrow: 'Sales',
    description: 'Sales module placeholder. We can wire sales collection workflows one section at a time.',
    requiredScopes: ['sales.view'],
  },
  {
    path: '/collections',
    label: 'Collections',
    iconKey: 'collections',
    eyebrow: 'Collections',
    description: 'Collections module placeholder. We can implement collection records and posting screens next.',
    requiredScopes: ['collections.view'],
  },
  {
    path: '/commissions',
    label: 'Commissions',
    iconKey: 'commissions',
    eyebrow: 'Commissions',
    description: 'Review commission records, tag releases, handle cancellations, and export payout reports.',
    requiredScopes: ['commissions.view'],
  },
  {
    path: '/finance',
    label: 'Finance',
    iconKey: 'finance',
    eyebrow: 'Finance',
    description: 'Manage payment requests, liquidation reports, and replenishment transactions.',
    requiredScopes: [
      'finance.payment-requests.view',
      'finance.liquidations.view',
      'finance.replenishments.view',
    ],
  },
  {
    path: '/branch-admin',
    label: 'Branch Management',
    iconKey: 'branchAdmin',
    eyebrow: 'Branch Management',
    description: 'Branch management module placeholder. We can add branch setup and monitoring screens later.',
    requiredScopes: ['branch-management.view'],
  },
  {
    path: '/reports',
    label: 'Reports',
    iconKey: 'reports',
    eyebrow: 'Reports',
    description: 'Generate filtered reports from collections, commissions, payment requests, liquidations, and replenishments.',
    requiredScopes: ['reports.view'],
  },
  {
    path: '/admin',
    label: 'Oauth Users',
    iconKey: 'admin',
    eyebrow: 'Oauth Users',
    description: 'Manage oauth users, branch assignments, and module action permissions.',
    requiredScopes: ['oauth-users.view'],
  },
];
